// This Stimulus controller is responsible for autoselecting the search map cards
// as they scroll into view on mobile.
stimulusApp.register(
  "search-map-card-autoselect",
  class extends Stimulus.Controller {
    static outlets = ["search-map-card"]

    connect() {
      this.observer = new IntersectionObserver(
        (entries) => {
          const entry = entries.find((e) => e.isIntersecting)
          // If any card is autofocusing now, don't interfere with it.
          if (
            entry &&
            !this.searchMapCardOutlets.some((outlet) => outlet.focusing)
          ) {
            const outlet = this.searchMapCardOutlets.find(
              (outlet) => outlet.element === entry.target,
            )
            outlet?.selectOnce()
          }
        },
        {
          root: this.element,
          threshold: 0.9,
        },
      )

      this.searchMapCardOutlets.forEach((outlet) => {
        this.observer.observe(outlet.element)
      })
    }

    searchMapCardOutletConnected(_outlet, element) {
      this.observer?.observe(element)
    }

    searchMapCardOutletDisconnected(_outlet, element) {
      this.observer?.unobserve(element)
    }

    disconnect() {
      this.observer.disconnect()
    }
  },
)
